import { Component, HostListener } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { CommonModule } from '@angular/common';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { InfoModalInterface } from './info-modal.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CommonEnums } from '../../modules/shared/enums/common.enum';
import { CommonService } from '../../modules/shared/services/common.service';
import { KEYBOARD_KEYS } from '../../constants/constant';
import { Button } from '../../modules/dynamic-form-builder/model/formBuilderInterface';
import { CircleBackgroundIconComponent } from '@components/circle-background-icon/circle-background-icon.component';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonComponent, CircleBackgroundIconComponent]
})
export class InfoModalComponent {
  icon!: string;
  icomoonClass: string;
  iconStyleClass!: string;
  heading!: string;
  description!: SafeHtml;
  subLabel!: string;
  buttonField!: Button;
  showCrossBtnImp!: boolean;
  showCrossBtn!: boolean;
  navigateUrl: string | null;
  closeModalOnEsc = true;
  headerClass: string;
  descriptionClass: string;

  constructor(
    private readonly modalService: BsModalService,
    private readonly router: Router,
    private readonly commonService: CommonService,
    private readonly sanitizer: DomSanitizer,
    public modalRef: BsModalRef
  ) {
    this.setValues();
  }
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === KEYBOARD_KEYS.ESCAPE && this.closeModalOnEsc && this.commonService.isBrowser) {
      this.closeModal();
    }
  }

  setValues() {
    const modalValues = this.modalService.config
      ?.initialState as InfoModalInterface;
    this.icon = modalValues.icon ?? '';
    this.iconStyleClass = modalValues.iconStyleClass ?? '';
    this.heading = modalValues.heading ?? '';
    this.description = this.sanitizeDescription(modalValues.description ?? '');
    this.subLabel = modalValues.subLabel ?? '';
    this.buttonField = modalValues.buttonField ?? ({} as Button);
    this.showCrossBtn = modalValues.showCrossBtn ?? true;
    this.showCrossBtnImp = modalValues.showCrossBtnImp ?? false;
    this.navigateUrl = modalValues.navigateUrl ?? null;
  }

  sanitizeDescription(description: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

  closeModal(isCrossClicked: boolean = false) {
    this.modalRef.hide();
    this.modalService.hide();
    if (
      !isCrossClicked &&
      this.buttonField.label === CommonEnums.VIEW_SUBSCRIPTION_PLAN
    ) {
      this.commonService.showSubscriptionPlan = true;
    }
    if (!isCrossClicked && this.navigateUrl) {
      this.router.navigate([this.navigateUrl]);
    }
  }
}
